import {
  TableCell as MuiTableCell,
  TableHead as MuiTableHead,
  TableHeadProps as MuiTableHeadProps,
  Table,
  TableBody,
  TableRow,
  makeStyles,
} from "@material-ui/core"
import React, { FC, MouseEvent, useState } from "react"
import { useHistory, useParams } from "react-router-dom"
import { colors } from "../../utils/theme"
import { Order } from "../../utils/types"
import TableCell from "../atoms/TableCell"

const useStyles = makeStyles((theme) => ({
  table: {
    color: colors.neutral.denim,
    borderRadius: 0,
    boxShadow: "none",
    border: `1px solid ${colors.neutral.clay}`,
    backgroundColor: colors.neutral.white,
  },
  tableHeaderCell: {
    color: colors.neutral.denim,
    fontWeight: 700,
    borderBottom: `1px solid ${colors.neutral.clay}`,
  },
  tableSortLabel: {
    color: `${colors.neutral.denim} !important`,
    fontWeight: 700,
  },
  noData: {
    width: "100%",
    padding: 27,
    textAlign: "center",
    border: `1px solid ${colors.neutral.clay}`,
    borderTop: 0,
    backgroundColor: colors.neutral.white,
  },
  noDataFirstLine: {
    fontWeight: 700,
    marginBottom: 6,
  },
  pending: {
    color: colors.neutral.asphalt,
    fontStyle: "italic",
  },
  questionnaireColumn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  questionnaireScore: {
    height: 33,
    width: 33,
    borderRadius: 4,
    padding: theme.spacing(1),
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  helpIconContainer: {
    display: "flex",
    alignItems: "center",
  },
  helpIcon: {
    marginLeft: theme.spacing(2),
    height: 24,
  },
  tableCell: {
    color: " #2F3B5A",
    cursor: "pointer",
    fontWeight: 400,
    borderBottom: "1px solid #C8CDDB",
    padding: theme.spacing(2),
  },
}))

interface Column {
  id: string
  label: string
}

type TableHeadProps = {
  order: Order
  orderBy: string
  onRequestSort: (event: MouseEvent<unknown>, property: string) => void
} & MuiTableHeadProps

const TableHead: FC<TableHeadProps> = ({ order, orderBy, onRequestSort }) => {
  const classes = useStyles()
  const createSortHandler =
    (property: string) => (event: MouseEvent<unknown>) => {
      onRequestSort(event, property)
    }
  const columns: Column[] = [
    {
      id: "lastName",
      label: "Last Name",
    },
    {
      id: "firstName",
      label: "First Name",
    },
    {
      id: "displayName",
      label: "Email",
    },
  ]
  return (
    <MuiTableHead>
      <TableRow>
        {columns.map((column) => (
          <MuiTableCell
            key={column.id}
            className={classes.tableHeaderCell}
            align={column.label === "" ? "right" : undefined}
            padding={column.label === "" ? "none" : undefined}
          >
            {column.label}
          </MuiTableCell>
        ))}
      </TableRow>
    </MuiTableHead>
  )
}

interface Params {
  id: string
}

interface PractitionerTableProps {
  practitioners: any[]
}

const PractitionerTable: FC<PractitionerTableProps> = ({ practitioners }) => {
  const classes = useStyles()
  const [order, setOrder] = useState<Order>("asc")
  const [orderBy, setOrderBy] = useState<string>("lastName")
  const history = useHistory()

  return (
    <>
      <Table className={classes.table}>
        <TableHead
          order={order}
          orderBy={orderBy}
          onRequestSort={(
            event: React.MouseEvent<unknown>,
            property: string
          ) => {
            const isAsc = orderBy === property && order === "asc"
            setOrder(isAsc ? "desc" : "asc")
            setOrderBy(property)
          }}
        />
        {practitioners && practitioners.length > 0 && (
          <TableBody>
            {practitioners.map((row, index) => {
              const onClick = () => {
                history.push(
                  `/supervisor/practitioners/${row.supervisees.id}/clients`,
                  {
                    name: `${row.supervisees.first_name} ${row.supervisees.last_name}`,
                  }
                )
              }
              return (
                <TableRow key={index}>
                  <TableCell
                    role="button"
                    onClick={onClick}
                    className={classes.tableCell}
                  >
                    {row.supervisees.last_name}
                  </TableCell>
                  <TableCell
                    role="button"
                    onClick={onClick}
                    className={classes.tableCell}
                  >
                    <div>{row.supervisees.first_name}</div>
                  </TableCell>
                  <TableCell
                    role="button"
                    onClick={onClick}
                    className={classes.tableCell}
                  >
                    {row.supervisees.display_name}
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        )}
      </Table>
    </>
  )
}

export default PractitionerTable
